<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title>{{HeaderTitle}}</ion-title>

        <ion-button title="fechar" style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end"
            (click)="Close($event)">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">

    <ion-grid class="full ion-no-margin ion-no-padding">

        <form [formGroup]="Form">

            <ion-row formArrayName="Modules">
                <ion-col class="parent" size="12" *ngFor="let module of Modules.controls; let m = index"
                    [formArrayName]="m">

                    <ion-item>
                        <ion-label>{{module?.get('Name').value}}</ion-label>
                        <ion-checkbox slot="start" formControlName="Checked"></ion-checkbox>
                    </ion-item>

                    <ion-row *ngIf="module.get('Checked')?.value" formArrayName="Groups">

                        <ion-col class="child" size="12" sizeMd="6"
                            *ngFor="let item of GetArrayControls(m).controls; let g = index" [formArrayName]="g">

                            <ion-card>
                                <ion-card-content>

                                    <ion-item>
                                        <ion-label>{{item.get('Name').value}}</ion-label>
                                        <ion-checkbox slot="start" formControlName="Checked"></ion-checkbox>
                                    </ion-item>


                                    <ion-row *ngIf="item.get('Checked')?.value">

                                        <ng-container
                                            *ngIf="GetGroupControls(m,g).get('Type')?.value==EnumTypeCampaign.WITH_EXPIRED_DATE">

                                            <ion-col size="12" sizeXl="6" style="padding-right: 6px;">

                                                <ion-item class="full" lines="none" fill="outline">

                                                    <ion-label position="stacked">Data Início</ion-label>

                                                    <ion-input [id]="'datepicker-module-datestart_'+m+'_'+g"
                                                        [disabled]="GetGroupControls(m,g).get('StartDate')?.disabled"
                                                        inputmode="none"
                                                        [value]="(GetGroupControls(m,g).get('StartDate')?.value|date:'dd-MM-yyyy')"
                                                        button readonly>
                                                        <ion-icon slot="end" name="calendar-outline"></ion-icon>
                                                    </ion-input>

                                                    <ion-popover [trigger]="'datepicker-module-datestart_'+m+'_'+g"
                                                        show-backdrop="false">
                                                        <ng-template>
                                                            <ion-datetime presentation="date" locale="pt" mode="md"
                                                                formControlName="StartDate"
                                                                [min]="GetGroupControls(m,g).get('CampaignStartDate')?.value"
                                                                [max]="MaxDate" [showDefaultButtons]="false">
                                                            </ion-datetime>
                                                        </ng-template>
                                                    </ion-popover>
                                                </ion-item>

                                            </ion-col>
                                            <ion-col size="12" sizeXl="6">
                                                <ion-item class="full" lines="none" fill="outline">

                                                    <ion-label position="stacked">Data Fim</ion-label>

                                                    <ion-input [id]="'datepicker-module-dateend_'+m+'_'+g"
                                                        [disabled]="GetGroupControls(m,g).get('EndDate')?.disabled"
                                                        inputmode="none"
                                                        [value]="(GetGroupControls(m,g).get('EndDate')?.value|date:'dd-MM-yyyy')"
                                                        button readonly>
                                                        <ion-icon slot="end" name="calendar-outline"></ion-icon>
                                                    </ion-input>

                                                    <ion-popover [trigger]="'datepicker-module-dateend_'+m+'_'+g"
                                                        show-backdrop="false">
                                                        <ng-template>
                                                            <ion-datetime presentation="date" locale="pt" mode="md"
                                                                [min]="GetGroupControls(m,g).get('StartDate')?.value || GetGroupControls(m,g).get('CampaignStartDate')?.value"
                                                                [max]="GetGroupControls(m,g).get('CampaignConfigValidationDays')?.value"
                                                                formControlName="EndDate" [showDefaultButtons]="false">
                                                            </ion-datetime>
                                                        </ng-template>
                                                    </ion-popover>
                                                </ion-item>
                                            </ion-col>

                                        </ng-container>

                                        <ng-container
                                            *ngIf="GetGroupControls(m,g).get('Type')?.value==EnumTypeCampaign.WITHOUT_EXPIRED_DATE">

                                            <ion-col class="ion-padding ion-text-center" size="12">
                                                <h2><b>Vitalício</b></h2>
                                            </ion-col>

                                        </ng-container>

                                        <ng-container
                                            *ngIf="GetGroupControls(m,g).get('Type')?.value==EnumTypeCampaign.DEFAULT && false">

                                            <ion-col size="12"></ion-col>

                                        </ng-container>
                                    </ion-row>

                                </ion-card-content>
                            </ion-card>


                        </ion-col>

                    </ion-row>
                </ion-col>
            </ion-row>

        </form>

    </ion-grid>

</ion-content>
<ion-footer>
    <ion-toolbar class="ion-padding-horizontal">
        <ion-button style="margin-right: -16px;" slot="end" fill="solid" color="medium"
            i18n=":@@modal_configuration_module.submit" (click)="OnSave($event)">Confirmar
        </ion-button>
    </ion-toolbar>
</ion-footer>